import riskpoint from "./API/riskpoint"
import patient from "./API/patient"
import datachart from "./API/datachart"

export default {
    riskpoint,
    patient,
    datachart
}
